import { render } from "./lyric.vue?vue&type=template&id=0f8f1321&scoped=true"
import script from "./lyric.vue?vue&type=script&lang=js"
export * from "./lyric.vue?vue&type=script&lang=js"

import "./lyric.vue?vue&type=style&index=0&id=0f8f1321&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f8f1321"]])

export default __exports__